import React from 'react';
import GoogleLogic from 'components/login/GoogleLogic';

const SignInFirstPage = ({onMissingUserName, onUserNameAndPassword}) => {

    return (
        <div>
            <h2 style={{marginTop: '15px', marginBottom: '15px', textAlign: 'center', color: '#595959'}}>Sign in</h2>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <GoogleLogic onMissingUserName={onMissingUserName}/>
            </div>

            <div className="divider">
                <span className="divider-text">or</span>
            </div>

            <div className="password-option">
                <div className="password-option-text" onClick={onUserNameAndPassword}>
                    Email & Verification
                </div>
            </div>
        </div>
    );
};

export default SignInFirstPage;
